import React from "react";
import { TextInput, maxLength } from "react-admin";
import { useFormState } from "react-final-form";

import { makeFormatter } from "../../../../components/formatter";
import { requiredIfTrue } from "../../../../utils/validation/requiredIfNoFieldValue";

const convertOutputValue = (value) => (value !== "" ? Number(value) : null);
const loadingOrderFormatter = (value) =>
	convertOutputValue(makeFormatter([{ char: /[\d]/, repeat: 3 }])(value));

export const LoadingOrderInput = ({ validate = [], ...props }) => {
	const { values } = useFormState();
	if (validate !== null) {
		validate = [maxLength(3), ...validate];
	}
	return <TextInput parse={loadingOrderFormatter} validate={validate} {...props} />;
};
